import { useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { BookingConfirmedStep, BookingThemedRoot } from 'src/modules/booking/components'
import { LoadingWrapperContext } from 'src/modules/core/context'

import classes from './booking-confirmed.module.scss'

export function BookingConfirmed() {
  const { disableLoading } = useContext(LoadingWrapperContext)
  const params = useParams()

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  return (
    <BookingThemedRoot providerId={params.providerId} className={classes.root}>
      <BookingConfirmedStep providerId={params.providerId} slug={params.slug} bookingId={params.bookingId} />
    </BookingThemedRoot>
  )
}
